import React from 'react'

export default function Header(props) {
    return (
        <div style={{ backgroundColor: 'white', color: 'black', padding: "20px" }}>
            <h3>{props.header}</h3>
        </div>
    )
}
